import {useState, useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom"
import styles from "./DetalleTest.module.css";
import RealizarTest from '../Test/RealizarTest';
import {useAuth} from '../../Auth/AuthContext'; 

const DetalleTest = () => {
    const { pa_clave, te_clave } = useParams();
    const navigate = useNavigate();
    const [test, setTest] = useState(null);
    const [paso, setPaso] = useState(null);
    const [elementosPaso, setElementosPaso] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mostrarRealizarTest, setMostrarRealizarTest] = useState(false);
    const [elementoAnterior, setElementoAnterior] = useState(null);
    const [siguienteElemento, setSiguienteElemento] = useState(null);
    const { getToken, userData } = useAuth();
    const token = getToken();

    // Función para recargar los datos del test
    const fetchTestDetails = async () => {
        const userId = userData.id;
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/test/obtener/${te_clave}/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const testData = await response.json();
            setTest(testData?.[0] || null);
        } catch (error) {
            console.error('Error al cargar el test:', error);
            setTest(null);
        }
    };

    useEffect(() => {
        const fetchPasoDetails = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso/${pa_clave}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
                const pasoData = await response.json();
                setPaso(pasoData?.[0] || null);
            } catch (error) {
                console.error('Error al cargar el paso:', error);
                setPaso(null);
            }
        };

        const fetchElementosPaso = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso-elementos/${pa_clave}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
                if (response.ok) {
                    const elementosData = await response.json();
                    const elementosOrdenados = elementosData.sort((a, b) => a.pael_orden - b.pael_orden);
                    setElementosPaso(elementosOrdenados);
                } else {
                    setElementosPaso([]);
                }
            } catch (error) {
                console.error('Error al cargar elementos del paso:', error);
                setElementosPaso([]);
            } finally {
                setLoading(false);
            }
        };

        if (te_clave && pa_clave) {
            fetchTestDetails();
            fetchPasoDetails();
            fetchElementosPaso();
        }
    }, [te_clave, pa_clave, token]);

    useEffect(() => {
        if (elementosPaso.length > 0) {
            const actual = elementosPaso.find(el => el.tipo === 'test' && el.id == te_clave);
            if (actual) {
                const indice = elementosPaso.findIndex(el => el.pael_orden === actual.pael_orden);
                setElementoAnterior(indice > 0 ? elementosPaso[indice - 1] : null);
                setSiguienteElemento(indice < elementosPaso.length - 1 ? elementosPaso[indice + 1] : null);
            }
        }
    }, [elementosPaso, te_clave]);

    const handleComenzarTest = () => {
        setMostrarRealizarTest(true);
    };

    // Función mejorada que actualiza el estado del test
    const handleVolverDeTest = async (testCompletado = false) => {
        setMostrarRealizarTest(false);
        
        // Si el test fue completado, actualizar los datos
        if (testCompletado) {
            await fetchTestDetails();
        }
    };

    const handleContinuar = async () => {
        if (siguienteElemento) {
            if (siguienteElemento.tipo === 'seccion') {
                navigate(`/paso/${pa_clave}/seccion/${siguienteElemento.id}`);
            } else if (siguienteElemento.tipo === 'test') {
                navigate(`/paso/${pa_clave}/test/${siguienteElemento.id}`);
            }
        } else {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/siguiente-paso/${paso.pa_numero}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
                if (response.ok) {
                    const siguientePasoData = await response.json();
                    navigate(siguientePasoData?.[0] ? `/paso/${siguientePasoData[0].pa_clave}` : '/temas');
                } else {
                    navigate('/temas');
                }
            } catch (error) {
                console.error('Error al buscar siguiente paso:', error);
                navigate('/temas');
            }
        }
    };

    const handleAnterior = async () => {
        if (elementoAnterior) {
            if (elementoAnterior.tipo === 'seccion') {
                navigate(`/paso/${pa_clave}/seccion/${elementoAnterior.id}`);
            } else if (elementoAnterior.tipo === 'test') {
                navigate(`/paso/${pa_clave}/test/${elementoAnterior.id}`);
            }
        } else {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso-anterior/${paso.pa_numero}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
                if (response.ok) {
                    const pasoAnteriorData = await response.json();
                    navigate(pasoAnteriorData?.[0] ? `/paso/${pasoAnteriorData[0].pa_clave}` : '/temas');
                } else {
                    navigate('/temas');
                }
            } catch (error) {
                console.error('Error al buscar paso anterior:', error);
                navigate('/temas');
            }
        }
    };

    if (loading) {
        return <div className={styles.loadingContainer}>Cargando test...</div>;
    }

    if (!test || !pa_clave || !te_clave) {
        return <div className={styles.loadingContainer}>Test no encontrado o parámetros inválidos</div>;
    }

    if (mostrarRealizarTest) {
        return <RealizarTest test={test} onBack={handleVolverDeTest} />;
    }

    return (
        <div className={styles.vistaContainer}>
            <div className={styles.cuerpoContainerTest}>
                <div className={styles.rowContainer}>
                    <h2>Test de {test.te_nombre}</h2>
                </div>
                <div className={styles.rowContainer}>
                    <p>{test.te_descripcion}</p>
                    <p>Tiempo estimado: {test.te_tiempo_estimado} min</p>
                    <p>Instrucciones: {test.te_instrucciones}</p>
                    <div className={styles.btnContainer}>
                        <button className={styles.startTestBtn} onClick={handleComenzarTest}>
                            Comenzar el test
                        </button>
                    </div>
                    <div className={styles.navigationButtons}>
                        <button onClick={handleAnterior} className={`${styles.btn} ${styles.btnVolverSeccion}`}>
                            {elementoAnterior ? 'Anterior' : 'Regresar al paso actual'}
                        </button>
                        <button onClick={handleContinuar} className={`${styles.btn} ${styles.btnVolverSeccion} ${
                            test.se_completado === 0 || test.se_completado === null || test.se_completado === undefined ? styles.btnDisabled : ''
                        }`}
                        disabled={test.se_completado === null || test.se_completado === 0}>
                            {siguienteElemento ? 'Siguiente' : 'Continuar al siguiente paso'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetalleTest;